/* eslint-disable quote-props */
/* eslint-disable max-len */
import _ from 'lodash';
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { questionSlotData } from '../../../models/FormSpecRegistry';
import { defaultEtoile } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_006: Question = {
  id: 'pres-006-territoire-vocation-conservation',
  oldId: '20',
  title: 'Territoire dont l’affectation et l’usage bénéficie d’une vocation de conservation',
  number: '2.6',
  description: [''],
  frequency: 3,
  type: QuestionType.INDICATOR,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      scoringFct: (data:number) => {
        if (data >= 21) return 3;
        if (data >= 11) return 2;
        if (data >= 6) return 1;
        return 0;
      },
      autofill: (values: any, sectionPath: string) => {
        const v1 = parseFloat(_.get(values, questionSlotData(sectionPath, 'pres-002-superficie-aires-protegees'))) || 0;
        const v2 = parseFloat(_.get(values, questionSlotData(sectionPath, 'pres-004-superficie-spcv'))) || 0;
        const v3 = parseFloat(_.get(values, questionSlotData(sectionPath, 'pres-005-superficie-espaces-conservation'))) || 0;
        const superficie = parseFloat(_.get(values, 'superficie')) || 1;
        return ((((v1 + v2 + v3) / 100) / superficie) * 100).toFixed(2);
      },
      maxScore: 3,
      help: defaultEtoile,
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

const question_pres_006__v3: Question = {
  ...question_pres_006,
  frequency: 2,
};

export const question_pres_006_v2: Question = question_pres_006;
export const question_pres_006_v3: Question = question_pres_006__v3;
